<template>
  <skills-list />
</template>

<script>
import skillsList from '@/components/lists/skills/skillsList'

export default {
    components: { skillsList },
}
</script>
